/**
 * Aviso de nueva versión.
 *
 * La aplicación NUNCA se recarga sola. El service worker nuevo se queda
 * esperando y aquí se pregunta.
 *
 * Con una sesión en curso ni siquiera se ofrece el botón: aplicar una
 * actualización recarga la página, y recargar a mitad de un entrenamiento
 * —justo cuando el usuario vuelve de ChatGPT Voice— es exactamente el fallo que
 * la especificación prohíbe. El aviso pasa a ser informativo hasta que termine.
 *
 * Pero informativo no puede significar «sin salida». Cerrar la aplicación del
 * todo también aplica la actualización —es el ciclo de vida normal de un
 * service worker cuando no le quedan clientes—, y quien empieza una sesión y
 * no vuelve en días necesita saberlo. Comprobado en Android: cerrar la PWA y
 * Chrome y reabrir entrega la versión nueva con la sesión abierta.
 */

import { useRegisterSW } from 'virtual:pwa-register/react';
import estilos from './ActualizacionPWA.module.css';

interface Props {
  /** Con una sesión abierta, la actualización espera. */
  sesionEnProgreso?: boolean;
}

export function ActualizacionPWA({ sesionEnProgreso = false }: Props) {
  const {
    needRefresh: [hayVersionNueva, setHayVersionNueva],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisterError(error) {
      console.error('No se pudo registrar el service worker', error);
    },
  });

  if (!hayVersionNueva) return null;

  if (sesionEnProgreso) {
    return (
      <div className={estilos.aviso} role="status" aria-live="polite">
        <p className={estilos.texto}>
          Hay una actualización disponible. Podés aplicarla cuando termines la sesión, o
          cerrando la aplicación del todo y volviéndola a abrir.
        </p>
      </div>
    );
  }

  return (
    <div className={estilos.aviso} role="status" aria-live="polite">
      <p className={estilos.texto}>Hay una versión nueva de la aplicación.</p>
      <div className={estilos.acciones}>
        <button
          type="button"
          className={estilos.principal}
          onClick={() => void updateServiceWorker(true)}
        >
          Actualizar
        </button>
        <button
          type="button"
          className={estilos.secundario}
          onClick={() => setHayVersionNueva(false)}
        >
          Ahora no
        </button>
      </div>
    </div>
  );
}
